import { getTimeOfDayMs } from '@witmetrics/utils/time';

export const classes = {
  wrapper: 'absolute w-full border-b-2 border-[#ef4444]',
  dot: 'size-3 rounded-full bg-[#ef4444] absolute left-0 top-[-5px] cursor-pointer',
};

export const styles = {
  wrapper: (offset: number, offsetTop: string) => ({
    filter: 'drop-shadow(0px 2px 5px hsla(0,0%,20%,0.25))',
    top: `calc(${offset}px + ${offsetTop})`,
  }),
};

export function getTimeOffset(hourHeight: number) {
  const totalLength = 24 * 60 * 60 * 1000; // 24 hours to ms
  return 24 * hourHeight * (getTimeOfDayMs() / totalLength);
}
